<template>
  <div>
    <v-toolbar dense class="elevation-1">
      <v-icon color="yellow" class="text-h4">mdi-account-school</v-icon>
      <v-toolbar-title
        :style="
          $vuetify.breakpoint.smAndUp
            ? 'letter-spacing: 0.5rem'
            : 'letter-spacing: 0.2rem'
        "
        class="ml-3 font-weight-bold"
      >
        {{ $t('student.student_title') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="darkpink" rounded dark @click="openDialog()">
        <v-icon left> mdi-plus-thick </v-icon>
        {{ $t('botoes.botao_novo') }}
      </v-btn>
      <v-dialog
        v-model="dialog"
        persistent
        :max-width="$vuetify.breakpoint.mdAndUp ? '40%' : '90%'"
      >
        <v-card class="rounded-lg">
          <v-card-title class="darkblue white--text">
            <span class="text-h5">{{ $t('botoes.botao_novoaluno') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form">
                <v-row>
                  <v-col cols="12" sm="6" md="7">
                    <v-text-field
                      color="blue"
                      v-model="formStudent.name"
                      :rules="[rules.required]"
                      :label="$t('label.label_nome')"
                      @change="doUser(formStudent.name)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="5">
                    <v-text-field
                      color="blue"
                      v-model="formStudent.user"
                      :rules="[rules.required, rules.user]"
                      :label="$t('label.label_usuario')"
                      readonly
                      :loading="userLoad"
                    ></v-text-field>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6">
                    <v-select
                      item-color="darkblue"
                      color="blue"
                      v-model="formStudent.schoolId"
                      :items="schools"
                      item-text="name"
                      item-value="id"
                      :label="$t('regisResponsavel.painel.escola')"
                      :no-data-text="$t('regisResponsavel.resgistrocadastro')"
                      :rules="[rules.option]"
                      @change="getTeams"
                    ></v-select>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="6" v-if="editMode">
                    <v-select
                      item-color="darkblue"
                      color="blue"
                      v-model="formStudent.teamId"
                      :items="teams"
                      item-text="name"
                      item-value="id"
                      :label="$t('regisResponsavel.painel.turma')"
                      :no-data-text="$t('regisResponsavel.resgistrocadastro')"
                      :rules="[rules.option]"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      color="blue"
                      :label="$t('label.label_email.email')"
                      :rules="[rules.email]"
                      v-model="formStudent.email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      offset-x
                      transition="slide-x-transition"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          color="darkblue"
                          v-model="computedDateFormatted"
                          :label="$t('label.label_datanascimento')"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-BR"
                        color="darkblue"
                        header-color="darkblue"
                        v-model="formStudent.birthday"
                        :active-picker.sync="activePicker"
                        :max="maxBirthDate"
                        min="1950-01-01"
                        @change="save"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" v-if="!editMode">
                    <v-text-field
                      color="blue"
                      v-model="formStudent.password"
                      :rules="[rules.required, rules.length(4)]"
                      :label="$t('label.label_senha.label_senhaob')"
                      :type="showPassword ? 'text' : 'password'"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <small>*{{ $t('regras.regra_obrigatorio') }}</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="darkpink" rounded text @click="closeRegister()">
              {{ $t('botoes.botao_cancelar') }}
            </v-btn>
            <v-btn color="darkpink" rounded text @click="saveBtn()">
              {{ $t('botoes.botao_salva') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-dialog v-model="dialogDelete" max-width="550px">
      <v-card
        class="rounded-lg py-3 error--text"
        style="border-left: 12px inset red"
      >
        <v-card-title>
          <v-icon left large color="error">mdi-alert-circle</v-icon>
          {{ $t('alerta.alerta_title') }}
        </v-card-title>
        <v-card-text class="black--text">
          {{ $t('alerta.alerta_excluir.excluir1') }}
        </v-card-text>
        <v-card-actions class="d-flex justify-end pr-4">
          <v-btn
            color="error"
            dark
            rounded
            class="px-3"
            @click="deleteItemConfirm()"
          >
            {{ $t('botoes.botao_excluir') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="resetDialog" max-width="550px">
      <v-card
        class="rounded-lg py-3 warning--text"
        style="border-left: 12px inset orange"
      >
        <v-card-title>
          <v-icon left large color="warning">mdi-alert-circle</v-icon>
          {{ $t('alerta.alerta_title') }}
        </v-card-title>
        <v-card-text class="black--text">
          {{ $t('alerta.alerta_dataAp') }}
        </v-card-text>
        <v-card-actions class="d-flex justify-end pr-4">
          <v-btn
            color="warning"
            dark
            rounded
            class="px-3"
            @click="resetPassword()"
          >
            {{ $t('admin.admin_restasenha') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="elevation-0 mt-1">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          color="blue"
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('label.label_pesquisa')"
          single-line
          hide-details
          :style="
            $vuetify.breakpoint.smAndUp ? 'max-width: 30%' : 'max-width: 60%'
          "
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="Students"
        :search="search"
        :footer-props="{
          'items-per-page-options': [20, 30, 45, 60, -1],
          'items-per-page-all-text': $t('events.events_headers.headers1'),
          'items-per-page-text': $t('student.student_paginas'),
          'show-first-last-page': true,
        }"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            small
            outlined
            rounded
            color="darkpink"
            class="px-2 mx-1"
            @click="resetItem(item)"
          >
            <v-icon small class="mr-1"> mdi-key-variant </v-icon>
            {{ $t('admin.admin_restasenha') }}
          </v-btn>
          <v-btn
            small
            outlined
            rounded
            color="darkblue"
            class="px-2 mx-1"
            @click="editItem(item)"
          >
            <v-icon small class="mr-1"> mdi-pencil </v-icon>
            {{ $t('botoes.botao_edita') }}
          </v-btn>
          <v-btn
            small
            outlined
            rounded
            color="error"
            class="px-2 mx-1"
            @click="deleteItem(item)"
          >
            <v-icon small class="mr-1"> mdi-delete </v-icon>
            {{ $t('botoes.botao_excluir') }}
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar
      v-model="successSnackbar"
      timeout="2500"
      elevation="3"
      class="mx-auto"
      bottom
      color="success"
      outlined
      text
    >
      <v-icon large color="success" class="mr-2">mdi-check-circle </v-icon>
      <span class="subtitle-1 black--text">
        {{ $t('alerta.alerta_sucesso') }}
      </span>
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="successSnackbar = false"
          rounded
          color="success"
          class="font-weight-black"
        >
          {{ $t('botoes.botao_ok') }}
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="errorSnackbar"
      timeout="2500"
      elevation="3"
      class="mx-auto"
      bottom
      color="error"
      outlined
      text
    >
      <v-icon large color="error" class="mr-2">mdi-close-circle </v-icon>
      <span class="subtitle-1 black--text">
        {{ $t('alerta.alerta_erro') }}!
      </span>
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="errorSnackbar = null"
          rounded
          color="error"
          class="font-weight-black"
        >
          {{ $t('botoes.botao_ok') }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<style scoped></style>

<script>
const url = process.env.VUE_APP_API_URL;
const axios = require("axios");

export default {
  data() {
    return {
      dialog: false,

      formStudent: {},

      search: "",

      headers: [
        {
          text: this.$t("login.login_usuario.usuario1"),
          value: "name",
        },
        {
          text: this.$t("certificado.cert_headers.headers2"),
          value: "user",
        },
        {
          text: this.$t("regisResponsavel.painel.escola"),
          value: "school.nickname",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
        },
      ],

      Students: [],

      editedIndex: -1,

      password: "",

      dialogDelete: false,

      editMode: false,

      activePicker: null,

      menu: false,

      dateFormatted: null,

      rules: {
        email: (v) =>
          !!(v || "").match(/@/) ||
          this.$t("regras.regra_email"),

        length: (len) => (v) =>
          (v || "").length >= len ||
          `${this.$t(
            "regras.regra_senhaMini.senha1"
          )} ${len} ${this.$t(
            "regras.regra_senhaMini.senha2"
          )}`,

        required: (v) =>
          !!v ||
          this.$t("regras.regra_obrigatorio"),

        option: (v) =>
          !!v ||
          this.$t("regras.regra_opcao"),

        image: (v) =>
          !!v ||
          this.$t("regras.regra_image"),

        question: (v) =>
          !!v ||
          this.$t("regras.regra_question"),

        date: (v) =>
          !!v ||
          this.$t("regras.regra_data"),

        user: (v) =>
          !!(v || "").match(
            /^[a-zA-Z0-9.]*$/
          ) ||
          this.$t("regras.regra_user"),

        none: true,
      },

      userExisting: false,

      successSnackbar: false,

      errorSnackbar: false,

      nameSchool: null,

      schoolName: [],

      showPassword: false,

      schools: [],

      teams: [],

      userLoad: false,

      resetDialog: false,
    };
  },

  computed: {
    /*
     * Token da API
     */
    token() {
      return (
        "Bearer " +
        localStorage.getItem("accessToken")
      );
    },

    /*
     * Data mostrada no campo de texto.
     *
     * Internamente:
     * YYYY-MM-DD
     *
     * Visualmente:
     * DD/MM/YYYY
     */
    computedDateFormatted() {
      return this.formatDate(
        this.formStudent.birthday
      );
    },

    /*
     * Não permite selecionar uma data futura.
     */
    maxBirthDate() {
      const date = new Date();

      date.setMinutes(
        date.getMinutes() -
          date.getTimezoneOffset()
      );

      return date
        .toISOString()
        .substr(0, 10);
    },
  },

  watch: {
    /*
     * Quando abrir o calendário,
     * começa mostrando o seletor de ano.
     */
    menu(val) {
      if (val) {
        setTimeout(() => {
          this.activePicker = "YEAR";
        });
      }
    },

    /*
     * Mantém dateFormatted atualizado.
     */
    "formStudent.birthday"(val) {
      this.dateFormatted =
        this.formatDate(val);
    },
  },

  methods: {
    /*
     * =========================================================
     * GERAR USUÁRIO
     * =========================================================
     */

    async doUser(name) {
      if (!name) {
        this.formStudent.user = "";
        return;
      }

      this.userLoad = true;

      try {
        name = this.removeAccents(name);

        const array = name
          .trim()
          .split(/\s+/);

        if (array.length === 0) {
          this.formStudent.user = "";
          return;
        }

        let user;

        if (array.length === 1) {
          user = array[0];
        } else {
          user =
            array[0] +
            "." +
            array[array.length - 1];
        }

        let result =
          await this.verifyUser(user);

        let i = 1;

        let tryUser = user;

        while (result) {
          tryUser = user + i;

          result =
            await this.verifyUser(
              tryUser
            );

          i++;
        }

        this.formStudent.user =
          tryUser.toLowerCase();
      } catch (error) {
        console.error(
          "Erro ao gerar usuário:",
          error
        );
      } finally {
        this.userLoad = false;
      }
    },

    /*
     * =========================================================
     * VERIFICAR USUÁRIO
     * =========================================================
     */

    async verifyUser(user) {
      try {
        const response =
          await axios.get(
            `${url}/students/user?user=${encodeURIComponent(
              user
            )}`,
            {
              headers: {
                authorization: this.token,
              },
            }
          );

        return response.data != null;
      } catch (error) {
        console.error(
          "Erro ao verificar usuário:",
          error
        );

        return false;
      }
    },

    /*
     * =========================================================
     * FORMATAR DATA
     * =========================================================
     *
     * Aceita:
     *
     * YYYY-MM-DD
     * YYYY-MM-DDTHH:mm:ss
     * DD/MM/YYYY
     * Date
     *
     * Retorna:
     *
     * DD/MM/YYYY
     */

    formatDate(date) {
      if (!date) {
        return null;
      }

      /*
       * Caso seja Date.
       */
      if (date instanceof Date) {
        if (isNaN(date.getTime())) {
          return null;
        }

        const day = String(
          date.getDate()
        ).padStart(2, "0");

        const month = String(
          date.getMonth() + 1
        ).padStart(2, "0");

        const year =
          date.getFullYear();

        return `${day}/${month}/${year}`;
      }

      date = String(date).trim();

      /*
       * Remove horário.
       *
       * Exemplo:
       *
       * 2020-05-10T00:00:00.000Z
       *
       * vira:
       *
       * 2020-05-10
       */
      if (date.includes("T")) {
        date = date.split("T")[0];
      }

      /*
       * YYYY-MM-DD
       */
      let match = date.match(
        /^(\d{4})-(\d{2})-(\d{2})$/
      );

      if (match) {
        const [, year, month, day] =
          match;

        return `${day}/${month}/${year}`;
      }

      /*
       * DD/MM/YYYY
       */
      if (
        /^\d{2}\/\d{2}\/\d{4}$/.test(
          date
        )
      ) {
        return date;
      }

      return null;
    },

    /*
     * =========================================================
     * CONVERTER DATA
     * =========================================================
     *
     * DD/MM/YYYY
     *
     * para
     *
     * YYYY-MM-DD
     */

    parseDate(date) {
      if (!date) {
        return null;
      }

      date = String(date).trim();

      /*
       * Já está em YYYY-MM-DD.
       */
      if (
        /^\d{4}-\d{2}-\d{2}$/.test(
          date
        )
      ) {
        return date;
      }

      /*
       * Remove horário.
       */
      if (date.includes("T")) {
        date = date.split("T")[0];
      }

      /*
       * DD/MM/YYYY
       */
      const match = date.match(
        /^(\d{2})\/(\d{2})\/(\d{4})$/
      );

      if (!match) {
        return null;
      }

      const [, day, month, year] =
        match;

      return `${year}-${month}-${day}`;
    },

    /*
     * =========================================================
     * DATA PARA SENHA
     * =========================================================
     *
     * 2020-05-10
     *
     * vira:
     *
     * 10052020
     */

    resetDate(date) {
      if (!date) {
        return null;
      }

      date = String(date).trim();

      /*
       * Remove horário.
       */
      if (date.includes("T")) {
        date = date.split("T")[0];
      }

      /*
       * YYYY-MM-DD
       */
      let match = date.match(
        /^(\d{4})-(\d{2})-(\d{2})$/
      );

      if (match) {
        const [, year, month, day] =
          match;

        return `${day}${month}${year}`;
      }

      /*
       * DD/MM/YYYY
       */
      match = date.match(
        /^(\d{2})\/(\d{2})\/(\d{4})$/
      );

      if (match) {
        const [, day, month, year] =
          match;

        return `${day}${month}${year}`;
      }

      return null;
    },

    /*
     * =========================================================
     * CALENDÁRIO
     * =========================================================
     */

    save(date) {
      if (this.$refs.menu) {
        this.$refs.menu.save(date);
      }

      this.menu = false;
    },

    /*
     * =========================================================
     * RESETAR SENHA
     * =========================================================
     */

    async resetPassword() {
      try {
        const password =
          this.resetDate(
            this.password
          );

        if (!password) {
          this.errorSnackbar = true;
          return;
        }

        const body = {
          password: password,
        };

        await axios.put(
          `${url}/students/password/${this.editedIndex}`,
          body,
          {
            headers: {
              authorization: this.token,
            },
          }
        );

        this.resetDialog = false;

        this.successSnackbar = true;
      } catch (error) {
        console.error(
          "Erro ao resetar senha:",
          error
        );

        this.errorSnackbar = true;
      }
    },

    /*
     * =========================================================
     * BUSCAR ALUNOS
     * =========================================================
     */

    async getStudent() {
      try {
        const response =
          await axios.get(
            `${url}/students`,
            {
              headers: {
                authorization: this.token,
              },
            }
          );

        this.Students =
          response.data;
      } catch (error) {
        console.error(
          "Erro ao buscar alunos:",
          error
        );
      }
    },

    /*
     * =========================================================
     * BUSCAR ESCOLAS
     * =========================================================
     */

    async getSchools() {
      try {
        const response =
          await axios.get(
            `${url}/schools`,
            {
              headers: {
                authorization: this.token,
              },
            }
          );

        this.schools =
          response.data;
      } catch (error) {
        console.error(
          "Erro ao buscar escolas:",
          error
        );
      }
    },

    /*
     * =========================================================
     * BUSCAR TURMAS
     * =========================================================
     */

    async getTeams() {
      if (!this.formStudent.schoolId) {
        this.teams = [];
        return;
      }

      try {
        const response =
          await axios.get(
            `${url}/teamsBySchool?school=${this.formStudent.schoolId}`,
            {
              headers: {
                authorization: this.token,
              },
            }
          );

        this.teams =
          response.data;
      } catch (error) {
        console.error(
          "Erro ao buscar turmas:",
          error
        );

        this.teams = [];
      }
    },

    /*
     * =========================================================
     * SALVAR
     * =========================================================
     */

    async saveBtn() {
      const validation =
        this.$refs.form.validate();

      if (!validation) {
        return;
      }

      /*
       * Garante que a data enviada
       * para a API seja YYYY-MM-DD.
       */
      if (this.formStudent.birthday) {
        const formatted =
          this.formatDate(
            this.formStudent.birthday
          );

        const parsed =
          this.parseDate(formatted);

        if (parsed) {
          this.formStudent.birthday =
            parsed;
        }
      }

      try {
        if (!this.editMode) {
          await this.registerStudent();
        } else {
          await this.updateStudent(
            this.formStudent.id
          );
        }

        this.editMode = false;

        this.successSnackbar = true;

        this.dialog = false;

        if (this.$refs.form) {
          this.$refs.form.reset();
        }
      } catch (error) {
        console.error(
          "Erro ao salvar aluno:",
          error
        );

        this.errorSnackbar = true;
      }
    },

    /*
     * =========================================================
     * ABRIR NOVO CADASTRO
     * =========================================================
     */

    openDialog() {
      this.dialog = true;

      this.editMode = false;

      this.formStudent = {};

      this.teams = [];

      this.showPassword = false;

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },

    /*
     * =========================================================
     * CADASTRAR ALUNO
     * =========================================================
     */

    async registerStudent() {
      try {
        await axios.post(
          `${url}/students`,
          this.formStudent,
          {
            headers: {
              authorization: this.token,
            },
          }
        );

        await this.StudentCard();

        await this.getStudent();
      } catch (error) {
        console.error(
          "Erro ao cadastrar aluno:",
          error
        );

        throw error;
      }
    },

    /*
     * =========================================================
     * ENVIAR CARTÃO
     * =========================================================
     */

    async StudentCard() {
      try {
        const user =
          this.formStudent.user;

        const schoolData =
          await this.getSchoolData(
            this.formStudent.schoolId
          );

        if (!schoolData) {
          return;
        }

        const body = {
          name:
            await this.shortenName(
              this.formStudent.name
            ),

          user: user,

          school:
            schoolData.nickname,

          city: schoolData.city,
        };

        await axios.post(
          `${url}/send-email/card`,
          body,
          {
            headers: {
              authorization: this.token,
            },
          }
        );
      } catch (error) {
        console.error(
          "Erro ao enviar cartão:",
          error
        );
      }
    },

    /*
     * =========================================================
     * DADOS DA ESCOLA
     * =========================================================
     */

    getSchoolData(id) {
      const index =
        this.schools.findIndex(
          (item) =>
            item.id === id
        );

      return index !== -1
        ? this.schools[index]
        : null;
    },

    /*
     * =========================================================
     * DADOS DA TURMA
     * =========================================================
     */

    getTeamData(id) {
      const index =
        this.teams.findIndex(
          (item) =>
            item.id === id
        );

      return index !== -1
        ? this.teams[index]
        : null;
    },

    /*
     * =========================================================
     * REDUZIR NOME
     * =========================================================
     */

    async shortenName(fullName) {
      if (!fullName) {
        return "";
      }

      fullName =
        this.removeAccents(
          fullName
        );

      const names = fullName
        .trim()
        .split(/\s+/);

      if (names.length <= 2) {
        return fullName.toUpperCase();
      }

      const firstName =
        names[0];

      const lastName =
        names[names.length - 1];

      const middleInitial =
        names
          .slice(
            1,
            names.length - 1
          )
          .map(
            (name) =>
              name.charAt(0)
          )
          .join(". ");

      return `${firstName} ${middleInitial}. ${lastName}`.toUpperCase();
    },

    /*
     * =========================================================
     * REMOVER ACENTOS
     * =========================================================
     */

    removeAccents(str) {
      if (!str) {
        return "";
      }

      const normalizedStr =
        str.normalize("NFD");

      return normalizedStr.replace(
        /[\u0300-\u036f]/g,
        ""
      );
    },

    /*
     * =========================================================
     * ATUALIZAR ALUNO
     * =========================================================
     */

    async updateStudent(id) {
      try {
        await axios.put(
          `${url}/students/${id}`,
          this.formStudent,
          {
            headers: {
              authorization: this.token,
            },
          }
        );

        await this.getStudent();
      } catch (error) {
        console.error(
          "Erro ao atualizar aluno:",
          error
        );

        throw error;
      }
    },

    /*
     * =========================================================
     * CONFIRMAR EXCLUSÃO
     * =========================================================
     */

    async deleteItemConfirm() {
      try {
        await axios.delete(
          `${url}/students/${this.editedIndex}`,
          {
            headers: {
              authorization: this.token,
            },
          }
        );

        this.dialogDelete = false;

        await this.getStudent();

        this.successSnackbar = true;
      } catch (error) {
        console.error(
          "Erro ao excluir aluno:",
          error
        );

        this.errorSnackbar = true;
      }
    },

    /*
     * =========================================================
     * FECHAR CADASTRO
     * =========================================================
     */

    closeRegister() {
      this.dialog = false;

      this.editMode = false;

      this.formStudent = {};

      this.teams = [];

      this.showPassword = false;

      this.menu = false;

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    /*
     * =========================================================
     * FECHAR EXCLUSÃO
     * =========================================================
     */

    closeDelete() {
      this.dialogDelete = false;

      this.$nextTick(() => {
        this.formStudent = {};

        this.editedIndex = -1;
      });
    },

    /*
     * =========================================================
     * EXCLUIR ITEM
     * =========================================================
     */

    deleteItem(item) {
      this.editedIndex = item.id;

      this.formStudent =
        Object.assign({}, item);

      this.dialogDelete = true;
    },

    /*
     * =========================================================
     * RESETAR SENHA DO ITEM
     * =========================================================
     */

    resetItem(item) {
      this.editedIndex = item.id;

      this.password =
        item.birthday;

      this.formStudent =
        Object.assign({}, item);

      this.resetDialog = true;
    },

    /*
     * =========================================================
     * EDITAR ITEM
     * =========================================================
     */

    async editItem(item) {
      this.editedIndex = item.id;

      this.formStudent =
        Object.assign({}, item);

      /*
       * Normaliza a data recebida
       * pela API para YYYY-MM-DD.
       */
      if (this.formStudent.birthday) {
        const formatted =
          this.formatDate(
            this.formStudent.birthday
          );

        const parsed =
          this.parseDate(
            formatted
          );

        if (parsed) {
          this.formStudent.birthday =
            parsed;
        }
      }

      this.dialog = true;

      this.editMode = true;

      await this.getTeams();

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
  },

  created() {
    this.getStudent();

    this.getSchools();
  },
};
</script>